// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ggugsgvsxjxurvvbdigc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdndWdzZ3ZzeGp4dXJ2dmJkaWdjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ1NzUwNTcsImV4cCI6MjA3MDE1MTA1N30.9WN1G1hF-gtWzqWw2kzX7l4RnwupSFH2u5vYvcfGiP4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});